export var DATE_FORMAT = 'YYYY-MM-DD';
export var DATE_DISPLAY_FORMAT = 'MMM D, YYYY';
export var MONTH_DISPLAY_FORMAT = 'MMMM YYYY';